import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { Icon } from "./icons";

// Home highlights, shared with the Mobile app: `featured` on songs/setlists, toggled via PUT /admin/{kind}/:id/featured.
export const setFeatured = (kind, id, featured) => api(`/admin/${kind}/${id}/featured`, { method: "PUT", body: JSON.stringify({ featured }) });

export function useFeatureToggle(kind) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, featured }) => setFeatured(kind, id, featured),
    onSuccess: () => ["songs", "admin-setlists", "home-setlists", "home", "setlist"].forEach((k) => qc.invalidateQueries({ queryKey: [k] })),
    onError: (e) => window.alert(e.message),
  });
}

/** Star button for admin lists. */
export function FeatureStar({ kind, item, toggle }) {
  const on = !!item.featured;
  return (
    <button className="icon-btn" onClick={() => toggle.mutate({ id: item.id, featured: !on })} aria-pressed={on} title={on ? "Retirar destaque da Home" : "Destacar na Home"} aria-label={on ? "Retirar destaque da Home" : "Destacar na Home"} data-testid={`feature-${kind}-${item.id}`}>
      <Icon name={on ? "star" : "star-outline"} size={16} color={on ? "var(--brand-primary)" : "var(--muted)"} />
    </button>
  );
}

export function HighlightToggle({ label, checked, onChange, testid }) {
  return (
    <label className="card" style={{ display: "flex", alignItems: "center", gap: 10, padding: 12, cursor: "pointer" }} data-testid={testid}>
      <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} style={{ accentColor: "var(--brand-primary)" }} data-testid={`${testid}-input`} />
      <span style={{ fontFamily: "var(--f-medium)", fontSize: 14 }}>{label}</span>
      <Icon name="star" size={14} color="var(--brand-primary)" />
    </label>
  );
}
